import { RGB } from './types';
import calculateLuminance from './calculateLuminance';

const getContrast = (lighterColor: RGB, darkerColor: RGB) => {
  // divided by .05 here according to this reference:
  // https://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
  const lighterColorLuminance = calculateLuminance(lighterColor);
  const darkerColorLuminance = calculateLuminance(darkerColor);
  const contrast =
    (lighterColorLuminance + 0.05) / (darkerColorLuminance + 0.05); // because floating points in JS are silly, round to 2 decimal points.

  return Math.round(contrast * 100) / 100;
}; // Reference: https://webaim.org/articles/contrast/#ratio
// This function assumes that text/foreground is passed first and
// background is passed second.

export default getContrast;
